import { Polygon } from './../model/polygon.model';
import { DatiUIU } from './../model/dati-uiu.model';
import { LoaderService } from './loader.service';
import { Injectable } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';

@Injectable({
    providedIn: 'root'
  })
export class PrintService {

  constructor(
    private loader: LoaderService
  ) {}

    getImage(htlmElementId: string, format: string = 'image/png', imgName: string = 'download', size?: {width: number, height: number}, x?: number, y?: number) {
      this.loader.show();
      this._download(htlmElementId, size, x, y).then(
        canvas => {
          this.loader.hide();
          const fileExt = format === 'image/png' ? '.png' : '.jpg';
          const content = canvas.toDataURL(format);
          // FileSaver.saveAs(content, imgName + fileExt);
          // console.log(format);
          var a = document.createElement("a"); //Create <a>
          a.href = content; //Image Base64 Goes here
          a.download = imgName + fileExt; //File name Here
          a.click(); //Downloaded file
        });
      }

    getPDF(pdfName: string = 'download', size: [number, number], image?: any, data?: DatiUIU, table?: Polygon[]) {
      let height;
      let width;
      if (size[1] > size[0]) {
        if (size[1] > 1000) {
          height = 1000;
          const perc = (1000 / size[1]) * 100;
          width = size[0] / 100 * perc;
        } else {
          width = size[0];
          height = size[1];
        }
      } else if (size[0] > size[1]) {
        if (size[0] > 1000) {
          width = 1000;
          const perc = ((size[0] - 1000) / size[0]) * 100;
          height= size[1] / 100 * perc;
        } else {
          width = size[0];
          height = size[1];
        }
      }
      const orientation = height < width ? 'l' : 'p';
      const pdf = new jspdf(orientation, 'pt', [width, height]);
      if (image) {
        pdf.addImage(image,'PNG', 0, 0, width, height);
      } else {
        const img: any = document.getElementById('canvas_background');
        pdf.addImage(img.href.baseVal,'PNG', 0, 0, width, height);
      }
      if (data) {
        pdf.setFontStyle('bold');
        pdf.setFontSize(18);
        const dataText = `Foglio: ${data.foglio} - Mappale: ${data.numero} - Subalterno: ${data.subalterno}`;
        pdf.text(dataText, 250, 30);
      }
      pdf.setFontStyle('italic');
      pdf.setFontSize(16);
      pdf.text(
        '*Le proporzioni del disegno sono soggette a variazioni in funzione della stampante utilizzata',
        25,
        900,
        undefined,
        90
      );
      if (table) {
        const data = [];
        const headers = [
          {
            'name': 'NORM.',
            'prompt': 'NORM.',
            'width': 150,
            'align': 'center',
            'padding': 0
          },
          {
            'name': 'ROOMS',
            'prompt': 'ROOMS',
            'width': 150,
            'align': 'center',
            'padding': 0
          },
          {
            'name': 'MACRO',
            'prompt': 'MACRO',
            'width': 150,
            'align': 'center',
            'padding': 0
          },
          {
            'name': 'COEFFICIENTE',
            'prompt': 'COEFFICIENTE',
            'width': 150,
            'align': 'center',
            'padding': 0
          },
          {
            'name': 'SUPERFICIE',
            'prompt': 'SUPERFICIE',
            'width': 125,
            'align': 'center',
            'padding': 0
          },
          {
            'name': 'ALERT',
            'prompt': 'ALERT',
            'width': 150,
            'align': 'center',
            'padding': 0
          }
        ];
        let supTotReale = 0;
        let supTotTaRI = 0;
        table.forEach(poly => {
          const roomsExt = poly.rooms.find(val => typeof val === 'string' && val.indexOf('external') !== -1);
          if (!roomsExt) {
            data.push(
              {
                'NORM.': poly.normalized ? poly.normalized[0] : '',
                'ROOMS': poly.rooms ? poly.rooms[0] : '',
                'MACRO': poly.macro ? poly.macro[0] : '',
                'COEFFICIENTE': poly.tari_coeff ? poly.tari_coeff[0] : '',
                'SUPERFICIE': poly.area,
                'ALERT': poly.alerts
              }
            );
            if (poly.normalized && 
              poly.normalized.length > 0 && 
              poly.tari_coeff && 
              poly.tari_coeff[0] !== undefined) {
                supTotTaRI += poly.area * poly.tari_coeff[0];
            }
            supTotReale += poly.area;
          }
        });
        const page2 = pdf.addPage('pt', 'p');
        page2.setFontSize(18);
        page2.text(`Superficie tot. Reale: ${supTotReale.toFixed(0)}mq`, 25, 50);
        page2.text(`Superficie tot. TaRI: ${supTotTaRI.toFixed(0)}mq`, 450, 50);
        page2.table(25, 70, data, headers, {
          printHeaders: true
        });
      }
      pdf.save(pdfName + '.pdf');
    }

    _download(htlmElementId: string, size?: {width: number, height: number}, x?: number, y?: number) {
        if (!htlmElementId) {
          return;
        } else {
          const data: any = document.getElementById('svgcontent').children[1];//document.getElementById(htlmElementId);
          const workarea = document.getElementById('workarea');
          workarea.scrollTo(0,0);
          let params =  {
            windowWidth: data.clientWidth,
            windowHeight: data.clientHeight,
            allowTaint: true, 
            useCORS: true,
            scale: 2.3,
            logging: true
          };
          if (size) {
            params = Object.assign(params, {
              width: size.width,
              height: size.height,
              windowWidth: size.width,
              windowHeight: size.height,
            });
          }
          if (x) {
            Object.assign(params, {
              x: x
            });
          }
          if (y) {
            Object.assign(params, {
              y: y
            });
          }
          return html2canvas(data, params);
        }
      }
}